import { useNavigate } from 'react-router-dom';

export const usePatientNavigation = () => {
  const navigate = useNavigate();

  const goToPatientDetail = (patientId) => {
    navigate(`/paciente/${patientId}`);
  };
  const goToPatientFMS = (patientId) => {
    navigate(`/paciente/${patientId}/fms`);
  };
  const goToPatientQuotes = (patientId) => {
    navigate(`/paciente/${patientId}/listacitas`);
  };
  const goToPatientServiceQuotes = (patientId, serviceId) => {
    navigate(`/paciente/${patientId}/listacitas/?serviceId=${serviceId}`);
  };

  return { goToPatientDetail,goToPatientFMS,goToPatientQuotes,goToPatientServiceQuotes };
};

export const useProfileNavigation = () => {
  const navigate = useNavigate();

  const goToProfileDetail = (profileId) => {
    navigate(`/perfil/${profileId}`);
  };

  return { goToProfileDetail };
};
